import React from "react";

/** Empty page w. Settings sidemenu */
const Settings: React.FC = () => {
  return <div></div>;
};

export default Settings;
